import { Control, Controller } from "react-hook-form";
import { AgentFileEntry, FilesField } from "../FilesField";

export const FilesFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FilesField
          files={field.value as AgentFileEntry[] | undefined}
          onFilesChange={field.onChange}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};
